module.exports = __webpack_public_path__ + "img/connection_hub.83705a08.svg";